module.exports = __webpack_public_path__ + "static/media/deptimage4.e701b1bb.JPG";